<template>
    <div class="products-ending-title">
        <div class="text" :class="{ simulator: productType === 'Simulator' || productType === 'MixMatch' }">
            <div class="text-left">Style3D</div>
            <div class="text-right">
                {{ productTypeComp }}
            </div>
        </div>

        <template v-if="productType === 'Fabric'">
            <div class="products-ending-img img-left-bottom img-left-bottom-fabric">
                <img :src="p3img8" />
            </div>
            <div class="products-ending-img img-right-bottom img-right-bottom-fabric">
                <img :src="p3img9" />
            </div>
        </template>
        <template v-if="productType === 'Studio'">
            <div class="products-ending-img img-left-bottom img-left-bottom-studio">
                <img :src="Studioendingimg1" />
            </div>
            <div class="products-ending-img img-right-bottom img-right-bottom-studio">
                <img :src="Studioendingimg2" />
            </div>
        </template>
        <template v-if="productType === 'Cloud'">
            <div class="products-ending-img img-left-bottom img-left-bottom-cloud">
                <img :src="Cloudendingimg1" />
            </div>
            <div class="products-ending-img img-right-center img-right-center-cloud">
                <img :src="Cloudendingimg2" />
            </div>
        </template>
        <template v-if="productType === 'One'">
            <div class="products-ending-img img-left-center img-left-center-one">
                <img :src="OneEndingImg1" />
            </div>
            <div class="products-ending-img img-right-center img-right-center-one">
                <img :src="OneEndingImg2" />
            </div>
        </template>
        <template v-if="productType === 'Atelier'">
            <div class="products-ending-img img-left-bottom img-left-bottom-atelier">
                <img :src="AtelierEndingImg1" />
            </div>
            <div class="products-ending-img img-right-center img-right-center-atelier">
                <img :src="AtelierEndingImg2" />
            </div>
        </template>
        <template v-if="productType === 'Simulator'">
            <div class="products-ending-img img-right-center img-right-center-simulator">
                <img :src="SimulatorEndingImg1" />
            </div>
        </template>
        <template v-if="productType === 'MixMatch'">
            <div class="products-ending-img img-right-center img-right-center-simulator">
                <img :src="MixMatchEndingImg1" />
            </div>
        </template>
        <template v-if="productType === 'Knit'">
            <div class="products-ending-img img-left-center img-left-center-knit">
                <img :src="KnitEndingImg1" />
            </div>
            <div class="products-ending-img img-right-center img-right-center-knit">
                <img :src="KnitEndingImg2" />
            </div>
        </template>
    </div>
</template>
<script lang="ts" setup>
    import { computed } from 'vue';
    import { gsap } from 'gsap';
    import { ScrollTrigger } from 'gsap/all';
    import p3img8 from '@assets/imgs/Products/Fabric/p3img8.png';
    import p3img9 from '@assets/imgs/Products/Fabric/p3img9.png';
    import Studioendingimg1 from '@assets/imgs/Products/Studio/endingimg1.png';
    import Studioendingimg2 from '@assets/imgs/Products/Studio/endingimg2.png';
    import Cloudendingimg1 from '@assets/imgs/Products/Cloud/endingimg1.png';
    import Cloudendingimg2 from '@assets/imgs/Products/Cloud/endingimg2.png';
    import OneEndingImg1 from '@assets/imgs/Products/One/endingimg1.png';
    import OneEndingImg2 from '@assets/imgs/Products/One/endingimg2.png';
    import AtelierEndingImg1 from '@assets/imgs/Products/Atelier/endingimg1.png';
    import AtelierEndingImg2 from '@assets/imgs/Products/Atelier/endingimg2.png';
    import SimulatorEndingImg1 from '@assets/imgs/Products/Simulator/endingimg1.png';
    import MixMatchEndingImg1 from '@assets/imgs/Products/MixMatch/endingimg1.png';
    import KnitEndingImg1 from '@assets/imgs/Products/Knit/endingimg1.png';
    import KnitEndingImg2 from '@assets/imgs/Products/Knit/endingimg2.png';

    import { ifCNLocale } from '~~/composables/useLocale.ts';

    const props = defineProps<
        Required<{
            productType: 'Cloud' | 'Fabric' | 'Studio' | 'Atelier' | 'Simulator' | 'One' | 'knit';
        }>
    >();

    const isCN = ifCNLocale();

    // 英文环境下Cloud显示为One
    const productTypeComp = computed(() => props.productType);

    gsap.registerPlugin(ScrollTrigger);

    onMounted(() => {
        // 文字出现
        const t1 = gsap.timeline({
            scrollTrigger: {
                // markers: { startColor: "green", endColor: "red", fontSize: "12px" },
                trigger: '.products-ending-title',
                // scrub: 1.2,// 延迟几秒滚动
                // start: "top 90%",
                start: 'top bottom',
                end: 'center center',
            },
        });
        t1.from(['.text-left', '.text-right'], {
            yPercent: 50,
            rotation: 5,
            opacity: 0,
            stagger: 0.1, // 动画间隔
        });
        // 图片
        gsap.from('.products-ending-img', {
            opacity: 0,
            delay: 0.3,
            scrollTrigger: {
                trigger: '.products-ending-img',
                start: 'top 100%',
            },
        });

        // 文字移动
        const t2 = gsap.timeline({
            scrollTrigger: {
                // markers: { startColor: "green", endColor: "red", fontSize: "12px" },
                trigger: '.products-ending-title',
                scrub: 1.2, // 延迟几秒滚动
                start: 'center 80%',
            },
        });
        t2.to('.text-left', {
            xPercent: 15,
        });
        t2.to(
            '.text-right',
            {
                xPercent: -15,
            },
            '<',
        );
    });
</script>

<style lang="less" scoped>
    .products-ending-title {
        position: relative;
        font-size: .convert(320px) [ @vw];
        font-weight: 500;
        font-family: Montserrat, 'HarmonyOS Sans SC';
        text-transform: capitalize;
        line-height: 1;
        // overflow: hidden;//studio左下有一个大图
        // margin: 0 auto;
        .text {
            .text-left {
                height: fit-content;
                width: 100%;
                height: auto;
                text-align: left;
            }

            .text-right {
                height: fit-content;
                width: 100%;
                text-align: right;
                user-select: none;
            }

            @media (max-width: @screen-mobile-width) {
                font-size: .convert(320px) [ @vw];
                &.simulator {
                    font-size: .convert(240px) [ @vw];
                }
            }
        }

        .products-ending-img {
            position: absolute;
        }

        .img-left-bottom {
            left: 0;
            bottom: 0;

            &-fabric {
                z-index: -1;

                img {
                    width: .convert(426px) [ @vw];
                    height: auto;
                }
            }

            &-studio {
                left: .convert(60px) [ @vw];
                bottom: .convert(22px) [ @vw];
                z-index: -1;
                img {
                    width: .convert(263px) [ @vw];
                    height: auto;
                }
            }

            &-cloud {
                left: .convert(70px) [ @vw];
                bottom: .convert(30px) [ @vw];
                z-index: 0;

                img {
                    width: .convert(150px) [ @vw];
                    height: auto;
                }
            }

            &-atelier {
                left: 0;
                bottom: .convert(30px) [ @vw];
                z-index: -1;

                img {
                    width: .convert(468px) [ @vw];
                    height: auto;
                }
            }
        }

        .img-right-bottom {
            right: 0;
            bottom: 0;

            &-fabric {
                bottom: 32%;
                z-index: -1;

                img {
                    width: .convert(426px) [ @vw];
                    height: auto;
                }
            }

            &-studio {
                right: .convert(30px) [ @vw];
                bottom: .convert(30px) [ @vw];
                z-index: -1;
                // @media (max-width: @screen-mobile-width) {
                //     top: .convert(-50px) [ @vw];
                // }
                img {
                    width: .convert(229px) [ @vw];
                    height: auto;
                }
            }
        }

        .img-left-center {
            right: 0;
            top: 35%;
            transform: translateY(-50%);

            &-one {
                left: .convert(40px) [ @vw];
                z-index: -1;

                img {
                    width: .convert(221px) [ @vw];
                    height: auto;
                }
            }
            &-knit {
                left: .convert(40px) [ @vw];
                z-index: -1;

                img {
                    width: .convert(210px) [ @vw];
                    height: auto;
                }
            }
        }

        .img-right-center {
            right: 0;
            top: 35%;
            transform: translate(0, -50%);

            &-cloud {
                right: .convert(50px) [ @vw];
                z-index: -1;

                img {
                    width: .convert(437px) [ @vw];
                    height: auto;
                }
            }

            &-atelier {
                top: 45%;
                right: .convert(-48px) [ @vw];
                z-index: -1;

                img {
                    width: .convert(510px) [ @vw];
                    height: auto;
                }
            }

            &-simulator {
                top: 45%;
                right: 0;
                z-index: -1;

                img {
                    width: .convert(469px) [ @vw];
                    height: auto;
                }
            }

            &-one {
                right: .convert(30px) [ @vw];
                z-index: -1;
                img {
                    width: .convert(251px) [ @vw];
                    height: auto;
                }
            }

            &-knit {
                right: .convert(30px) [ @vw];
                z-index: -1;
                img {
                    width: .convert(210px) [ @vw];
                    height: auto;
                }
            }
        }
    }
</style>
